module.exports = __webpack_public_path__ + "static/media/LDR.560e6655.svg";